import { BOOKS, API_BASE } from "../utils/constants";

export default class GotService {
  getResource = async url => {
    const res = await fetch(`${API_BASE}${url}`)

    if (!res.ok) {
      throw new Error(`Could not fetch ${url}, status: ${res.status}`)
    }
    return await res.json()
  }

  getAllItems = async (itemType, pageNum = 5, pageSize = 12) => {
    const res = await this.getResource(`/${itemType}?${itemType === BOOKS ? `books` : `page`}=${pageNum}&pageSize=${pageSize}`)
    return res.map(this._transformItem)
  }

  getItem = async (itemType, itemId) => {
    const res = await this.getResource(`/${itemType}/${itemId}`)
    return this._transformItem(res)
  }

  _transformItem = data => {
    this._isSet(data)
    data['id'] = this._extractId(data)

    if (data.hasOwnProperty('ancestralWeapons')) {
      data['ancestralWeapons'] = this._toString(data['ancestralWeapons'])
    }
    if (data.hasOwnProperty('released')) {
      data['released'] = this._toNormalDateFormat(data['released'])
    }
    if (data.hasOwnProperty('titles')) {
      data['titles'] = this._toString(data['titles'])
    }

    return { ...data }
  }

  _isSet = data => {
    for (let key in data) {
      if (!data[key]) {
        data[key] = 'No information'
      } else if (Array.isArray(data[key]) && data[key].every(item => !item)) {
        data[key][0] = 'No information'
      }
    }
    return data
  };

  _extractId = ({ url }) => {
    const idRegExp = /\/([0-9]*)$/
    return url.match(idRegExp)[1]
  }

  _extractItemName = item => {
    return item.split("s?")[0]
  }

  _toString = arr => {
    return arr.join(', ')
  }

  _toNormalDateFormat = str => {
    return str.split("T")[0]
  }
}

